export default [
  {
    path: '/reports',
    name: 'reports',
    component: () => import('@/views/reports/Index.vue'),
    meta: {
      resource: 'Reports',
      action: 'read',
      pageTitle: 'Reports',
      breadcrumb: [
        {
          text: 'Reports',
          active: true
        }
      ],
    },
  }
]
